<template>
  <div>
    <!-- 编辑用户时，用户信息加载失败 -->
    <div class="fail" v-if="isShowFail">当前用户信息加载失败，请重试！</div>
    <!-- ① :model校验指定校验xx对象中的属性, 指定xx对象以外的属性不生效 -->
    <el-form
        ref="ruleFormRef"
        :model="configServerInfo"
        status-icon
        :rules="rules"
        label-width="140px"
        class="rule_form"
        size="large"
        v-loading="loading"
        v-if="!isShowFail"
    >
      <el-form-item label="Key(配置项名称)" prop="key">
        <el-input
            v-model="configServerInfo.key"
            placeholder="请输入key值"
            :disabled="isEdit"
            clearable
        ></el-input>
      </el-form-item>

      <el-form-item
          v-if="configServerInfo.key != 'GroupNoticeContent'"
          label="Value(配置项值)"
          prop="value"
      >
        <el-input
            type="textarea"
            v-model="configServerInfo.value"
            style="max-height: 360px; overflow: auto" 
            placeholder="请输入value值"
            :autosize="{ minRows: 2, maxRows: 18 }"
            clearable
        ></el-input>
        <el-col :span="24">
          <div style="color:#fd5252;font-size:14px;margin-left:10px;">
            注：请务必慎重填写，如有疑问请联系技术
          </div>
        </el-col
        >
        <el-col :span="24">
          <div style="margin-top: 10px">
            <el-button @click="changeImg" type="primary">插入图片</el-button>
          </div>
        </el-col>
      </el-form-item>

      <el-form-item v-else label="Value(配置项值)" prop="value">
        <Editor
            ref="Editor"
            class="liveEditor"
            placeholderText="请输入文章内容,不能为空"
            :fContent="configServerInfo.value"
            @cContent="editorContent"
            editorId="myEditor"
        ></Editor>
        <span style="color:#fd5252;font-size:14px;margin-left:10px;mar"
        >注：请务必慎重填写，如有疑问请联系技术</span
        >
        <div style="margin-top: 10px">
          <el-button @click="changeImg" type="primary">插入图片</el-button>
        </div>
      </el-form-item>
      <el-form-item label="配置项描述备注" prop="comment">
        <el-input
            type="textarea"
            v-model="configServerInfo.comment"
            placeholder="请输入备注"
            :autosize="{ minRows: 2, maxRows: 8 }"
            clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="from_btn">
      <el-button size="large" @click="onCancel">取消</el-button>
      <el-button
          size="large"
          type="primary"
          :disabled="isSubmitDisabled"
          v-if="!isSubmitDisabled"
          @click="onSubmit(ruleFormRef)">提交保存
      </el-button
      >
      <el-button type="primary" size="large" loading v-else>提交中</el-button>
    </div>

    <el-dialog
        v-model="uploadDialog"
        :close-on-click-modal="false"
        ref="uploadDialogRef"
        :fullscreen="false"
        title="插入图片"
        @close="closeDialog"
        width="750px"
        class="abow_dialog all_dialog"
        append-to-body
        draggable
        destroy-on-close
        :before-close="beforeClose"
    >
      <ConfigImageUpload
          ref="ImageUploadRef"
          :isYes="true"
          :imagePath="imagePath"
          :isReduce="false"
          @change-imagePath="setImageContent"
          @close-dialog="closeDialogImage"
      ></ConfigImageUpload>
    </el-dialog>
  </div>
</template>

<script>
import {ElMessage, ElMessageBox} from "element-plus";
import ConfigImageUpload from "./ConfigImageUpload";
import {AddConfig, UpConfig} from "../../network/configServer";
import Editor from "components/wangEditor/WangEditor.vue";
import {isNull} from "../../common/utils";
import {ref, reactive, toRefs, unref} from "vue";

export default {
  name: "AddConfigServerData",
  components: {
    ConfigImageUpload,
    Editor,
  },
  props: {
    editTarget: Number,
    isEdit: {
      type: Boolean,
      default: false,
    },
    EditInfo: {
      type: Object,
      default: () => {
      },
    },
    namespaceName: {
      type: String,
      default: "",
    },
  },
  setup(props, {emit}) {
    const ImageUploadRef = ref(null);

    var validatorKey = (rule, value, callback) => {
      if (!value) {
        callback(
            new Error("请填写Key值，并且只能输入数字或字母或数字字母的组合")
        );
      } else if (/[\W]/g.test(value)) {
        callback(new Error("只能输入数字和字母的组合"));
        data.configServerInfo.key = data.configServerInfo.key.replace(
            /[\W]/g,
            ""
        );
      } else {
        callback();
      }
    };
    var validatorComment = (rule, value, callback) => {
      var len = 0;
      if (value == null) {
        value = "";
      }
      for (var i = 0; i < value.length; i++) {
        var c = value.charCodeAt(i);
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
          len++;
        } else {
          len += 2;
        }
      }
      const {name, number} = rule;
      if (len > number) {
        callback(new Error(name));
      } else {
        callback();
      }
    };
    const data = reactive({
      rules: {
        key: [
          {
            required: true,
            validator: validatorKey,
            trigger: ["blur", "change"],
          },
        ],
        value: [
          {
            required: true,
            message: "请输入value",
            trigger: ["blur", "change"],
          },
        ],
        comment: [
          {
            required: true,
            message: "请输入配置描述信息",
            trigger: "blur",
          },
          {
            validator: validatorComment,
            trigger: ["blur", "change"],
            name: "字符长度不能超过100个字",
            number: 200,
          },
        ],
      },
      configServerInfo: {
        namespaceName: "",
        key: "",
        value: "",
        comment: "",
      },
      loading: false,
      uploadDialog: false,
      imagePath: "",
      oldImgUrl: [],
      isSubmitDisabled: false,
      temp:{}
    });

    if (
        props.EditInfo != null &&
        !isNull(props.EditInfo.value) &&
        /^http:/.test(props.EditInfo.value)
    ) {
      data.oldImgUrl.push(props.EditInfo.value);
    }
    if (props.EditInfo) {
      data.configServerInfo = JSON.parse(JSON.stringify(props.EditInfo));
    }
    // 富文本编辑器
    const editorContent = (val) => {
      data.configServerInfo.value = val.html;
    };
    // 插入图片
    const changeImg = () => {
      data.uploadDialog = true;
      if (/^http:/.test(data.configServerInfo.value)) {
        data.imagePath = data.configServerInfo.value;
      }
    };
    // 图片更新
    const setImageContent = (val) => {
      if (typeof val == "string" && data.oldImgUrl.indexOf(val) == -1) {
        data.oldImgUrl.push(val);
      }
      data.configServerInfo.value = val;
    };
    // 提交

    const onSubmit = async () => {
      const form = unref(ruleFormRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          return false;
        } else {
          data.isSubmitDisabled = true;
          submitPost(data.configServerInfo).then(() => {
            data.isSubmitDisabled = false;
          });
        }
      } catch (error) {
        ElMessage.error("有必填内容未填写！");
        console.log(error);
      }
    };

    // 提交数据请求
    const submitPost = async () => {
      const isEdit = props.isEdit;
      let result = "";
      if (props.namespaceName == "") {
        ElMessage.error("数据获取失败");
        return;
      }
      data.configServerInfo.namespaceName = props.namespaceName;
      if (isEdit && isEdit === true) {
        result = await UpConfig(data.configServerInfo);
      } else {
        result = await AddConfig(data.configServerInfo);
      }
      data.loading = false;
      if (result.code === 1) {
        var isEditText = isEdit ? "编辑成功！" : "添加成功！";
        ElMessageBox.alert(isEditText + "需要点击发布才能生效。", {
          confirmButtonText: "确认",
        });
        emit("close-dialog");
        emit("update-list", data.configServerInfo.value, data.oldImgUrl);
      } else {
        ElMessageBox.alert(result.message, {
          confirmButtonText: "确认",
        });
      }
    };
    // 重置
    const resetForm = () => {
      ruleFormRef.value.resetFields();
    };
    const beforeClose = (done) => {
      data.temp = ImageUploadRef.value;
      done();
    }
    // 取消
    const onCancel = () => {
      if (props.isEdit) {
        resetForm();
      }
      if (data.temp && Object.keys(data.temp).length !=0) {
        data.temp.cancelData();
        data.temp = {}
      }
      // if (ImageUploadRef.value) {
      //   ImageUploadRef.value.cancelData();
      // }
      (data.configServerInfo = {}), emit("close-dialog");
    };
    const closeDialog = () => {
      data.uploadDialog = false;
    };
    const closeDialogImage = () => {
      data.uploadDialog = false;
      data.temp = ImageUploadRef.value;
      ElMessageBox.alert("配置项的值已更改成功，请保存之后立即点击发布！", {
        confirmButtonText: "确认",
      });
    };
    const ruleFormRef = ref();
    return {
      ruleFormRef,
      ImageUploadRef,
      ...toRefs(data),
      editorContent,
      changeImg,
      setImageContent,
      onSubmit,
      submitPost,
      resetForm,
      onCancel,
      closeDialog,
      closeDialogImage,
      beforeClose,
    };
  },
};
</script>

<style scoped>
.rule_form {
  padding: 0 30px 0 15px
}

.el-form-item {
  margin-bottom: 24px !important;
}

.btn-area {
  margin-top: 48px;
}

.fail {
  text-align: center;
  color: #959595;
}

.el-textarea >>> .el-textarea__inner {
  max-height: 360px;
  overflow: auto;
}

.abow_dialog >>> .el-dialog__body {
  height: 400px;
}
</style>
